import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';

import type {StagesetBasic as StagesetBasicFragment} from 'nutshell-graphql-types';

import {PipelineListItem} from './pipeline-list-item';

type Props = {
    stagesets: StagesetBasicFragment[];
};

export const PipelineList = (props: Props) => {
    if (props.stagesets.length === 0) {
        return null;
    }

    return (
        <Stack spacing={16}>
            {props.stagesets.map((stageset) => {
                return (
                    <PipelineListItem
                        key={stageset.id}
                        stageset={stageset}
                        shouldPreventDragging={true}
                    />
                );
            })}
        </Stack>
    );
};
